import { EntitiesStore } from "./entities-store.abstract";
import { HttpClient } from "@angular/common/http";
import { ComboStoreComponent, CategoryCombo, AthleteCategoriesCombo } from '../filters-store/filters-store';
import { IAthleteCategories } from './athlete-biography-store';
import { withLatestFrom, tap, map, mergeMap } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';

export interface IAthleteRecords {
  RecordTypeId: number;
  RecordLevelId: number;
  RecordDiscipline: number;
  RecordArea: number;
  RecordName: string;
  RecordSubName: string;
  RecordStanding: boolean;
  RecordHistorical: boolean;
  Cat: string;
  ParaAr: boolean;
  IsTeam: boolean;
  Date: Date;
  Points: number;
  Xs: number;
  OldPoints: number;
  OldXs: number;
  MaxPoints: number;
  Shared: boolean;
  Competition: IRecordCompetition;
  NOC: string;
  Archers: IAthlete[] | IAthlete;
  Team?: string;
}

export interface IAthlete {
  Id: number;
  FName: string;
  GName: string;
  WNameOrd: number;
}

export interface IRecordCompetition {
  ID: number;
  Name: string;
  Place: string;
  Country: string;
}

export class AthleteRecordsStore extends EntitiesStore<IAthleteRecords> {
  constructor(http: HttpClient) {
    super("RECORDS", http, []);
  }
}


/**
 *
 *
 * @export
 * @class AthleteRecordsCategoriesCombo
 * @extends {AthleteCategoriesCombo}
 */
export class AthleteRecordsCategoriesCombo extends ComboStoreComponent<
  IAthleteCategories
  > {
  /**
   *Creates an instance of AthleteCategoriesCombo.
   * @param {*} name_filter the name of the filter.
   * @param {*} id the id of the filter.
   * @param {Array<{ item: IAthleteCategories; position: number }>} extraOptions extra options if any.
   * @param {HttpClient} http The http service.
   * @param {boolean} filterTeam if the categories of the combo should be filtered by team or not.
   * @memberof AthleteCategoriesCombo
   */
  constructor(
    name_filter,
    id,
    extraOptions: Array<{ item: IAthleteCategories; position: number }>,
    http: HttpClient,
    public athleteId: string
  ) {
    // tslint:disable-next-line:max-line-length
    super(name_filter, 'CatName', id, undefined, undefined, http, undefined, [], [
      { entity: new AthleteCategoriesCombo(name, id, extraOptions, http, undefined) }
    ])
    this.comboInfo.initial_state = true;
  }

  /**
   *
   * @inheritdoc
   * @returns
   * @memberof AthleteCategoriesCombo
   */
  getRequest() {
    this.loadingRef = true;
    return super.getRequest({}, false).pipe(
      mergeMap(a => {
        const entity = this.dependencies[0].entity.data;
        const queries = entity.map(value =>
          new AthleteRecordsStore(this.http).requestData({ RecordLevel: 2, CatId: value['CatId'], Id: this.athleteId }, false));
        const queries_broken = entity.map(value =>
          new AthleteRecordsStore(this.http).requestData({ BrokenRecords: true, RecordLevel: 2, CatId: value['CatId'], Id: this.athleteId }, false));
        const queries_historical = entity.map(value =>
            new AthleteRecordsStore(this.http).requestData({ Historical: true, RecordLevel: 2, CatId: value['CatId'], Id: this.athleteId }, false));

        return forkJoin(queries.concat(queries_broken).concat(queries_historical));
      }),
      map(a => {
        const recordItems = [].concat.apply([], (a as any).
          map(value => value.items).filter(value => value.length > 0)).reduce((f, s) => f.set(s.Cat, s.Cat), new Map());
        const categories = this.dependencies[0].entity.data.filter(value => recordItems.has(value.Code));
        this.data = categories;
        const sortOrder = Array.from(this.data).sort((f, s) => f['CatId'] > s['CatId'] ? 1 : -1);
        this.comboInfo.options_selected_subject.next(sortOrder[0]);
        this.comboInfo.options_subject.next(this.data);
        return a;
      })
    );

  }
}
